import type { Action } from 'flow/store/engine/types';
import { ActionType } from 'flow/store/engine/constants';
import { createActionsThunk } from 'flow/store/redux/thunks';
import {
  findNextActionPrecedence,
  PREVIEW_OUTCOME_ACTION_NAME,
  getOutcomeBaseColor,
} from 'flow/service/actions';

import type { useAppDispatch } from '~/store/reduxHooks';


export function handleOnAddOutcomeClick(
  dispatch: ReturnType<typeof useAppDispatch>,
  outcomeActions: Action[],
  publicId?: Action['publicId'],
) {
  const name = PREVIEW_OUTCOME_ACTION_NAME;
  const precedenceIndex = findNextActionPrecedence(outcomeActions);

  dispatch(createActionsThunk({
    type: ActionType.OUTCOME,
    args: {
      name,
      precedenceIndex,
      color: getOutcomeBaseColor(name),
      isCaseStatus: false,
      rules: {},
      isEphemeral: false, // set to default - this is a preview action at this point
      ...(publicId && { publicId }),
    },
  }));
}
